/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./common');

window.Vue = require('vue');

import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents, {
    swipeTolerance: 90
});

// /**
//  * The following block of code may be used to automatically register your
//  * Vue components. It will recursively scan this directory for the Vue
//  * components and automatically register them with their "basename".
//  *
//  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
//  */

// // const files = require.context('./', true, /\.vue$/i);
// // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('request-service-component', require('./components/RequestServiceComponent.vue').default);
Vue.component('my-mics-component', require('./components/MyMicsComponent.vue').default);

// Vue.component('rode-carousel-component', require('./components/microsites/RodeCarouselComponent.vue').default);
// Vue.component('rode-column-componenent', require('./components/microsites/RodeColumnComponent.vue').default);
const micrositefiles = require.context('./components/microsites/', true, /\.vue$/i);
micrositefiles.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], micrositefiles(key).default));

const formparts = require.context('./components/forms/', true, /\.vue$/i);
formparts.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], formparts(key).default));

// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */

// const app = new Vue({
//     el: '#app',
// });